if (!customElements.get("collection-grid-group-slider")) {
  customElements.define(
    "collection-grid-group-slider",
    class CollectionGridGroupSlider extends HTMLElement {
      connectedCallback() {
        this.gridList = this.querySelector("grid-list");
        if (!this.gridList) return;

        const items = parseInt(this.dataset.items) || 4;
        const itemsTabletLarge =
          parseInt(this.dataset.itemsTabletLarge) || items;
        const itemsTablet =
          parseInt(this.dataset.itemsTablet) || itemsTabletLarge;

        this.classList.add("swiper");
        this.gridList.classList.add("swiper-wrapper");

        this.sliderOptions = {
          slidesPerView: 1.5,
          spaceBetween: 12,
          slidesOffsetAfter: 16,
          breakpoints: {
            768: {
              slidesPerView: itemsTablet,
              spaceBetween: 20,
              slidesOffsetAfter: 16,
            },
            1024: {
              slidesPerView: itemsTabletLarge,
              spaceBetween: 20,
              slidesOffsetAfter: 16,
            },
            1280: {
              slidesPerView: 3.2,
              spaceBetween: 20,
              slidesOffsetAfter: 16,
            },
          },
          threshold: 2,
          grabCursor: true,
          allowTouchMove: true,
          observer: true,
          observeParents: true,
          pagination: {
            el: this.querySelector(".collection-grid-group-slider__pagination"),
            type: "progressbar",
          },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(
          this,
          this.sliderOptions,
        );
        this.sliderInstance.init();
      }
    },
  );
}
